import React from "react";
import PropTypes from "prop-types";
import "../css/cards.css";

const AlertCard = ({ alert }) => (
  <div className="alert-card" style={{ borderLeftColor: alert.color }}>
    <div className="alert-header">
      <h3>{alert.title}</h3>
      <span className="alert-timestamp">{alert.timestamp}</span>
    </div>
    <p className="alert-description">{alert.description}</p>
  </div>
);

AlertCard.propTypes = {
  alert: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    timestamp: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
  }).isRequired,
};

export default AlertCard;